import React, { useMemo, useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { Row, Col } from "react-bootstrap";

function AboutCard() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 480);

  // Check for mobile and small screen on resize
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsSmallScreen(width <= 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Memoize the career metrics data
  const careerMetrics = useMemo(() => [
    { value: "5+", label: "Years Experience" },
    { value: "50K+", label: "Concurrent Users" },
    { value: "5000+", label: "Databases Managed" },
    { value: "$10M+", label: "Transactions Processed" }
  ], []);

  // Memoize the activities data
  const activities = useMemo(() => [
    "Leading architectural reviews and mentoring senior development teams",
    "Writing technical blogs and sharing architectural best practices",
    "Contributing to open-source projects and technical communities",
    "Speaking at tech conferences and conducting technical workshops"
  ], []);

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ 
            textAlign: isMobile ? "left" : "justify",
            fontSize: isSmallScreen ? "clamp(0.9rem, 3.5vw, 1.1rem)" : isMobile ? "clamp(1rem, 3vw, 1.2rem)" : "1.1rem",
            lineHeight: "1.7",
            marginBottom: "20px"
          }}>
            Hi Everyone, I am <span className="purple">Hassan Abrar</span> from <span className="purple">Lahore, Pakistan.</span> I am a <span className="purple">Senior Software Architect</span> with 5+ years of experience specializing in enterprise-scale system design, distributed architectures, and high-performance backend solutions.
          </p>

          <p style={{ 
            textAlign: isMobile ? "left" : "justify",
            fontSize: isSmallScreen ? "clamp(0.9rem, 3.5vw, 1.1rem)" : isMobile ? "clamp(1rem, 3vw, 1.2rem)" : "1.1rem",
            lineHeight: "1.7",
            marginBottom: "20px"
          }}>
            I have architected and implemented enterprise-grade systems that handle 50,000+ concurrent users, designed microservices platforms with 15+ distributed services, and processed over $10M in financial transactions. My expertise spans from designing scalable microservices architectures and implementing real-time data processing pipelines to building secure, compliant financial systems and leading development teams of 8+ senior engineers.
          </p>

          <p style={{ 
            textAlign: isMobile ? "left" : "justify",
            fontSize: isSmallScreen ? "clamp(0.9rem, 3.5vw, 1.1rem)" : isMobile ? "clamp(1rem, 3vw, 1.2rem)" : "1.1rem",
            lineHeight: "1.7",
            marginBottom: "20px"
          }}>
            I specialize in <span className="purple">System Architecture Design</span>, <span className="purple">Cloud-Native Solutions</span>, <span className="purple">Performance Optimization</span>, and <span className="purple">Enterprise Security</span>. My track record includes achieving 99.99% uptime SLAs, reducing infrastructure costs by 70%, and improving system scalability by 300%.
          </p>

          {/* Career Overview Metrics */}
          <div style={{ 
            margin: isSmallScreen ? "20px 0" : isMobile ? "25px 0" : "30px 0",
            padding: isSmallScreen ? "15px 0" : "20px 0"
          }}>
            <h4 style={{ 
              color: "#c770f0", 
              marginBottom: isSmallScreen ? "15px" : "20px", 
              textAlign: "center",
              fontSize: isSmallScreen ? "clamp(1.2rem, 4vw, 1.5rem)" : isMobile ? "clamp(1.3rem, 3.5vw, 1.6rem)" : "1.5rem"
            }}>
              Career Highlights
            </h4>
            <Row>
              {careerMetrics.map((metric, index) => (
                <Col md={3} sm={6} xs={6} key={index} style={{ marginBottom: isSmallScreen ? "10px" : "15px" }}>
                  <div style={{
                    backgroundColor: "rgba(199, 112, 240, 0.1)",
                    border: "1px solid rgba(199, 112, 240, 0.2)",
                    borderRadius: isSmallScreen ? "8px" : "10px",
                    padding: isSmallScreen ? "12px 8px" : isMobile ? "15px 10px" : "15px",
                    textAlign: "center"
                  }}>
                    <h3 style={{ 
                      color: "#c770f0", 
                      margin: "0 0 5px 0", 
                      fontSize: isSmallScreen ? "clamp(1.4rem, 5vw, 1.6rem)" : isMobile ? "clamp(1.5rem, 4vw, 1.7rem)" : "1.8em" 
                    }}>
                      {metric.value}
                    </h3>
                    <p style={{ 
                      color: "white", 
                      margin: 0, 
                      fontSize: isSmallScreen ? "clamp(0.7rem, 2.5vw, 0.8rem)" : isMobile ? "clamp(0.8rem, 2.5vw, 0.9rem)" : "0.9em",
                      lineHeight: "1.3"
                    }}>
                      {metric.label}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

          <p style={{ 
            textAlign: isMobile ? "left" : "justify",
            fontSize: isSmallScreen ? "clamp(0.9rem, 3.5vw, 1.1rem)" : isMobile ? "clamp(1rem, 3vw, 1.2rem)" : "1.1rem",
            lineHeight: "1.7",
            marginBottom: "15px"
          }}>
            Apart from architecting systems, some other activities that I love to do!
          </p>
          
          <ul style={{ 
            paddingLeft: isSmallScreen ? "20px" : isMobile ? "25px" : "30px",
            marginBottom: "20px"
          }}>
            {activities.map((activity, index) => (
              <li key={index} className="about-activity" style={{
                fontSize: isSmallScreen ? "clamp(0.85rem, 3vw, 1rem)" : isMobile ? "clamp(0.9rem, 2.8vw, 1.05rem)" : "1rem",
                lineHeight: "1.6",
                marginBottom: isSmallScreen ? "8px" : "10px"
              }}>
                <ImPointRight style={{ 
                  color: "#c770f0", 
                  marginRight: "8px",
                  fontSize: isSmallScreen ? "0.8rem" : "0.9rem"
                }} /> 
                {activity}
              </li>
            ))}
          </ul>

          <p style={{ 
            color: "rgb(155 126 172)",
            fontSize: isSmallScreen ? "clamp(0.9rem, 3.5vw, 1.1rem)" : isMobile ? "clamp(1rem, 3vw, 1.2rem)" : "1.1rem",
            fontStyle: "italic",
            textAlign: isMobile ? "center" : "left",
            marginBottom: "10px"
          }}>
            "Architecting scalable solutions that transform businesses and drive technological innovation!"
          </p>
          
          <footer className="blockquote-footer" style={{
            fontSize: isSmallScreen ? "clamp(0.8rem, 3vw, 0.9rem)" : isMobile ? "clamp(0.85rem, 2.8vw, 0.95rem)" : "0.9rem",
            textAlign: isMobile ? "center" : "right",
            color: "#c770f0",
            fontWeight: "600"
          }}>
            Hassan Abrar
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default React.memo(AboutCard);
